import React, { useCallback } from "react";
import IosShareOutlinedIcon from "@mui/icons-material/IosShareOutlined";
import { theme } from "../../theme/colors";

const INVITE_URL = "https://civixthread.com";
const INVITE_SUBJECT = "Join CivixThread";
const INVITE_BODY = `I'm helping build the civic network representatives cannot ignore. Join me on CivixThread: ${INVITE_URL}`;

export default function InviteSomeoneCard({ onNotify }) {
  const handleInviteClick = useCallback(async () => {
    if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
      try {
        await navigator.share({ title: INVITE_SUBJECT, text: INVITE_BODY });
        return;
      } catch (err) {
        if (err?.name === "AbortError") return;
      }
    }

    try {
      await navigator.clipboard?.writeText(INVITE_BODY);
      onNotify?.("Invite message copied to clipboard.", "success");
      return;
    } catch {
      // fall through to mailto
    }

    try {
      const mailtoLink = document.createElement("a");
      mailtoLink.href = `mailto:?subject=${encodeURIComponent(INVITE_SUBJECT)}&body=${encodeURIComponent(INVITE_BODY)}`;
      mailtoLink.rel = "noopener noreferrer";
      document.body.appendChild(mailtoLink);
      mailtoLink.click();
      mailtoLink.remove();
    } catch {
      onNotify?.(`Copy this invite link: ${INVITE_URL}`, "info");
    }
  }, [onNotify]);

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm xl:min-w-[320px] 2xl:min-w-[360px]">
      <h3 className="text-sm font-semibold text-slate-900">Grow the civic network</h3>
      <p className="mt-2 text-sm text-slate-700">
        Invite friends and neighbors so more voices reach the people who represent you.
      </p>
      <button
        type="button"
        onClick={handleInviteClick}
        className="mt-3 inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold text-white shadow-md hover:opacity-95 transition-opacity w-full"
        style={{ background: theme.gradient }}
      >
        <IosShareOutlinedIcon sx={{ fontSize: 18 }} aria-hidden="true" />
        Invite someone
      </button>
    </section>
  );
}
